import { render } from "./ThankYou.vue?vue&type=template&id=cae7f79c"
import script from "./ThankYou.vue?vue&type=script&lang=js"
export * from "./ThankYou.vue?vue&type=script&lang=js"

import "./ThankYou.vue?vue&type=style&index=0&id=cae7f79c&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__